import React, { Component } from 'react';
import { Analytics } from '@vercel/analytics/react';
import './App.css';
import Preloader from './appshell/Preloader/Preloader';
import LandingHead from './components/LandingHead/LandingHead';
import LandingTimeline from './components/LandingTimeline/LandingTimeline';



class App extends Component {

  constructor(props) {
    super(props);
    this.state = {spinner: true}
    this.handleLoad = this.handleLoad.bind(this);
    this.timeoutId = null;
  }

  handleLoad() {
    // Preloader state is managed by React, no need for jQuery DOM manipulation
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    // Ensure spinner is hidden when window loads
    this.setState({ spinner: false });
    const preloaderShown = sessionStorage.getItem('preloaderShown');
    if (!preloaderShown) {
      sessionStorage.setItem('preloaderShown', 'true');
    }
  }

  componentDidMount() {
    // Check if window already loaded (for fast connections or cached pages)
    if (document.readyState === 'complete') {
      this.handleLoad();
      return;
    }

    window.addEventListener('load', this.handleLoad);

    const preloaderShown = sessionStorage.getItem('preloaderShown');
    if (preloaderShown) {
      this.setState({ spinner: false });
    } else {
      // Fallback timeout to ensure preloader always hides
      this.timeoutId = setTimeout(() => {
        this.setState({ spinner: false });
        sessionStorage.setItem('preloaderShown', 'true');
      }, 2000);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.handleLoad);
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  render() {
    return (
      <div className="App">
        {this.state.spinner ? <Preloader /> : null}

        <LandingHead />
        <LandingTimeline />
        <Analytics />
      </div>
    );
  }
}



export default App;
